<template>
  <div class="bg-gray-200 py-12 lg:py-36">
    <div class="grid-default container">
      <Heading
        v-if="data.title"
        semantic
        class="col-span-6 mb-8 text-3xl text-blue-950 lg:col-span-5 lg:mb-0 lg:text-6xl"
      >
        {{ data.title }}
      </Heading>
      <div class="col-span-6 lg:col-span-7">
        <template v-if="data.headline && data.html">
          <div class="mb-3 text-base font-semibold text-blue-800 lg:mb-9 lg:text-4xl">
            {{ data.headline }}
          </div>
          <div class="text-base text-neutral-500 lg:text-4xl" v-html="data.html" />
        </template>
        <template v-else>
          <AccordionSegments :data="segmentsData" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionSegmentRecord } from '~/types/generated'
const { locale } = useI18n()

const segmentsData = ref([])

const props = defineProps({
  data: {
    type: Object as PropType<SectionSegmentRecord>,
    default: () => {}
  }
})

const { data: segments } = await useAsyncGql('segments', {
  // @ts-ignore
  locale
})

if (segments.value) {
  segmentsData.value = segments.value.allSegments
}

// Add CMS Overrides
if (Array.isArray(props.data.overrideSegments) && props.data.overrideSegments.length) {
  segmentsData.value.unshift(...props.data.overrideSegments)
  segmentsData.value = segmentsData.value.slice(0, props.data.overrideSegments.length)
}
</script>
